// Хелперы для генерации schema.org разметки (JSON-LD) из уже существующих
// данных страниц. Контент не дублируется — переиспользуем meta/faq/статьи.

const SITE_NAME = "Boostclick";

const origin = () =>
  typeof window !== "undefined" ? window.location.origin : "https://boostclick.ru";

const currentUrl = () =>
  typeof window !== "undefined"
    ? window.location.origin + window.location.pathname
    : "https://boostclick.ru";

// FAQ-ответы в проекте — это JSX (React-узлы), а не строки. Для JSON-LD нужен
// plain-text, поэтому рекурсивно достаём текст из детей узла.
function nodeToText(node) {
  if (node == null || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(nodeToText).join(" ");
  if (node.props && node.props.children) return nodeToText(node.props.children);
  return "";
}

export function reactNodeToText(node) {
  return nodeToText(node).replace(/\s+/g, " ").trim();
}

// "02.04.2024" (DD.MM.YYYY) -> "2024-04-02"
function ddmmyyyyToISO(str) {
  if (typeof str !== "string") return undefined;
  const m = str.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : undefined;
}

export function buildOrganization() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: origin(),
    logo: origin() + "/apple-touch-icon.png",
  };
}

export function buildService({ name, description }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    url: currentUrl(),
    provider: {
      "@type": "Organization",
      name: SITE_NAME,
      url: origin(),
    },
  };
}

export function buildFaqPage(faq) {
  if (!Array.isArray(faq)) return null;
  const mainEntity = faq
    .map((item) => ({
      "@type": "Question",
      name: reactNodeToText(item.title),
      acceptedAnswer: {
        "@type": "Answer",
        text: reactNodeToText(item.text),
      },
    }))
    .filter((q) => q.name && q.acceptedAnswer.text);

  if (!mainEntity.length) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity,
  };
}

export function buildArticle(article) {
  if (!article) return null;
  const published = ddmmyyyyToISO(article.data);
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.metaTitle || article.title,
    description: article.metaDescription,
    ...(article.imageUrl ? { image: origin() + article.imageUrl } : {}),
    ...(published ? { datePublished: published, dateModified: published } : {}),
    author: { "@type": "Organization", name: SITE_NAME },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: {
        "@type": "ImageObject",
        url: origin() + "/apple-touch-icon.png",
      },
    },
    mainEntityOfPage: currentUrl(),
  };
}
